import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-933eea58"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "button__badge"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Webordre", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Messages = _resolveComponent("Messages")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      _createVNode(_component_Messages)
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_Button, {
        type: "inertia-link",
        href: _ctx.link('orders.index', { type: 'orders' }),
        class: "span-2 home-button",
        color: "green"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, {
            class: "icon",
            type: "mdi",
            path: _ctx.openOrdersIcon
          }, null, 8, ["path"]),
          _createTextVNode("Åpne ordre ")
        ]),
        _: 1
      }, 8, ["href"]),
      _createVNode(_component_Button, {
        type: "inertia-link",
        href: _ctx.link('orders.index', { type: 'weborders' }),
        class: "span-2 home-button",
        color: "green"
      }, {
        default: _withCtx(() => [
          (_ctx.countWebOrders > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.countWebOrders), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_SvgIcon, {
            class: "icon",
            type: "mdi",
            path: _ctx.webordersIcon
          }, null, 8, ["path"]),
          _hoisted_2
        ]),
        _: 1
      }, 8, ["href"]),
      _createVNode(_component_Button, {
        type: "a",
        href: "/cash-till/old-orders",
        class: "home-button",
        color: "green"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, {
            class: "icon",
            type: "mdi",
            path: _ctx.previousOrdersIcon
          }, null, 8, ["path"]),
          _createTextVNode("Tidligere ordre ")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        type: "inertia-link",
        href: _ctx.link('products.index'),
        class: "home-button",
        color: "green"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, {
            class: "icon",
            type: "mdi",
            path: _ctx.productListIcon
          }, null, 8, ["path"]),
          _createTextVNode("Produktliste ")
        ]),
        _: 1
      }, 8, ["href"]),
      _createVNode(_component_Button, {
        type: "a",
        href: "/customers/list",
        class: "home-button",
        color: "secondary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, {
            class: "icon",
            type: "mdi",
            path: _ctx.customerListIcon
          }, null, 8, ["path"]),
          _createTextVNode("Kunderegister ")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        type: "a",
        href: "/cash-till/#customers-new",
        class: "home-button",
        color: "secondary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, {
            class: "icon",
            type: "mdi",
            path: _ctx.newCustomerIcon
          }, null, 8, ["path"]),
          _createTextVNode("Ny kunde ")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        type: "a",
        href: "/products/list-backorder",
        class: "home-button",
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, {
            class: "icon",
            type: "mdi",
            path: _ctx.backorderListIcon
          }, null, 8, ["path"]),
          _createTextVNode("Bestillingsliste ")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        type: "a",
        href: "/hours/register",
        class: "home-button",
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, {
            class: "icon",
            type: "mdi",
            path: _ctx.hoursIcon
          }, null, 8, ["path"]),
          _createTextVNode("Registrer timer ")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        type: "a",
        href: "/reports/registry",
        class: "home-button",
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, {
            class: "icon",
            type: "mdi",
            path: _ctx.newRegistryIcon
          }, null, 8, ["path"]),
          _createTextVNode("Registrer oppgjør ")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        type: "a",
        target: "_blank",
        href: _ctx.webstoreLink,
        class: "home-button",
        color: "accent"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, {
            class: "icon",
            type: "mdi",
            path: _ctx.webstoreIcon
          }, null, 8, ["path"]),
          _createTextVNode("Nettbutikk ")
        ]),
        _: 1
      }, 8, ["href"])
    ])
  ]))
}